import {Component, OnInit} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NzFormModule} from 'ng-zorro-antd/form';
import {isArray} from 'lodash-es';

@Component({
  selector: 'zorrly-select',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzFormModule,
  ],
  template: `
    <div *ngIf="optionsIsArray; else unable" style="margin: 20px 0;">
      <ng-container *ngFor="let select of props.selects">
        <nz-form-item>
          <nz-form-label [nzRequired]="noMissing">{{ select.label }}</nz-form-label>
          <nz-form-control>
            <nz-select [formControl]="$any(_form).get(select.key)"
                       (ngModelChange)="updateVal(select.key)">
              <nz-option *ngFor="let o of $any(props.options)" [nzLabel]="o.label"
                         [nzValue]="o.value"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </ng-container>
      <div *ngIf="formControl.dirty && formControl.errors" class="ant-form-item-explain-error">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
    <ng-template #unable>
      <div style="color:red">Unable to get options: {{ props.options | json }}</div>
    </ng-template>
  `,
})
export class ZorrlyMultiSelectComponent extends FieldType implements OnInit {

  _form = new FormGroup({});
  noMissing = true;

  constructor() {
    super();
  }

  async ngOnInit() {
    this.noMissing = this.field.validators?.validation.some((v: string) => v === 'no-missing');
    this.props.selects.forEach((s: any) => {
      this._form.addControl(s.key, new FormControl({
        value: null,
        disabled: this.props.disabled ?? false
      }, this.noMissing ? [Validators.required] : []));
    });
    this._form.patchValue(this.formControl.value);
  }

  updateVal(key: string) {
    const value = this._form.get(key)?.value;
    if (!!value) {
      const controlWithSameVal = Object.keys(this._form.controls)
        .find(k => k !== key && this._form.get(k)?.value === value);
      if (!!controlWithSameVal) {
        const ctrl = this._form.get(controlWithSameVal);
        ctrl?.reset();
        ctrl?.markAsDirty();
        ctrl?.markAsTouched();
        ctrl?.updateValueAndValidity();
      }
    }
    this.formControl.patchValue(this._form.value);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }

  get optionsIsArray(): boolean {
    return isArray(this.props.options);
  }

}
